import React from 'react'
import styled from 'styled-components'

const Border = styled.div`
  padding: 3px;
  margin: 0 5px 10px 5px;
  width: 48px;
  height: 48px;
  border: 1px solid #707070;
  border-radius: 4px;
`

const BG = styled.div`
  display: block;
  width: 100%;
  height: 100%;
  border-radius: 2px;

  background-color: ${props => props.bg};
`

const Color = ({ backgroundColor, onClick }) => (
  <Border onClick={onClick}>
    <BG bg={backgroundColor} />
  </Border>
)

export default Color



// WEBPACK FOOTER //
// ./src/components/CollectionColors/Color.js